import React from 'react';
import styled from 'styled-components';
import Game from './components/Game';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const Header = styled.header`
  background-color: #4CAF50;
  color: white;
  padding: 20px;
  text-align: center;
`;

const App: React.FC = () => {
  return (
    <AppContainer>
      <Header>
        <h1>Set Card Game</h1>
        <p>Find sets of three cards where each feature is either all the same or all different!</p>
      </Header>
      <Game />
    </AppContainer>
  );
};

export default App; 